<div class="body-container-wrapper">
    <section class="retirement-home-page-banner p-0">
        <div class="container-fluid" style=" margin-bottom: 10px;">
            <div class="row align-items-start">
                <div class="col-md-8 col-sm-12">
                    <figure>
                        <img src="../../../../assets/images/tax-campaign/new1.webp" alt="" class="banner-img">
                    </figure>
                </div>
                <!-- Form Section -->
                <div class="col-md-4 col-sm-12">
                    <div class="card banner-form">
                        <div class="card-body" *ngIf="isLeadFormVisible">
                            <h3 class="form-title">Fill in the Details to get your <br><span id="freetext">FREE</span> Tax-Saving Guide!</h3>
                            <p id="fill-form" style="color: red; display: none;">Fill in all the details to proceed further.</p>
                            <form #leadForm="ngForm" (ngSubmit)="PostData(leadForm)">
                                <div class="form-group">
                                    <label for="">Name<span class="asterisk"></span></label>
                                    <input type="text" autocomplete="off"
                                        id="name" name="name" [(ngModel)]="name" class="form-control"
                                        (blur)="removeErrorMsg('name')" placeholder="Please enter your full name"
                                        maxlength="40" 
                                        inputmode="text" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
                                        (keydown)="alphaOnly($event)">
                                    <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
                                        Invalid full name
                                    </div>
                                    <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
                                        Full name is mandatory
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="">Email Addresss </label>
                                    <input type="text" autocomplete="off"(keydown.space)="$event.preventDefault();" id="email" name="email"
                                        [(ngModel)]="email" class="form-control" placeholder="Your email id"
                                        maxlength="50" (blur)="removeErrorMsg('email')">
                                    <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
                                        Invalid email i
                                    </div>
                                    <div class="errormsg" *ngIf="emailValidateMessage == 'required'">
                                        Email id is mandatory
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="">Mobile Number<span class="asterisk"></span></label>
                                    <input type="text" (keydown.space)="$event.preventDefault();" autocomplete="off" id="mobile"
                                        name="mobile" [(ngModel)]="mobile" class="form-control"
                                        placeholder="Enter Your mobile number" minlength="10" maxlength="10"
                                        pattern="[6789][0-9]{9}" (blur)="removeErrorMsg('mobile')"
                                        inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                                        (keypress)="numbersOnly($event)">
                                    <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
                                        10 digit mobile number is mandatory
                                    </div>
                                    <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
                                        Invalid mobile number
                                    </div>
                                    <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
                                        Mobile number is mandatory
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="">Pincode <span class="asterisk"></span></label>
                                    <input type="text" autocomplete="off" id="pincode" name="pincode" [(ngModel)]="pincode" class="form-control"
                                        placeholder="Your pincode" pattern="^[1-9][0-9]{5}$" minlength="6" maxlength="6"
                                        (click)="openSuggestionBox($event,'form')"
                                        (blur)="hideSuggestionDiv('form')"
                                        (keyup)="getPincodeList($event,'form')"
                                        (keypress)="numberspincode($event)">
                                    <div class="errormsg" *ngIf="pinValidateMessage == 'invalid'">
                                        Invalid pincode
                                    </div>
                                    <div class="errormsg" *ngIf="pinValidateMessage == 'required'">
                                        Pincode is mandatory
                                    </div>
                                    <div class="errormsg" *ngIf="pinValidateMessage == 'notselected'">
                                        Pincode selection from the list is mandatory
                                    </div>

                                    <div class="suggestion-box" id="suggestion-box" *ngIf="hideSuggestion">
                                        <ng-container *ngFor="let pin of pincodeArr">
                                            <a class="pointer" (mousedown)="setpincode(pin,'form')">
                                                <div style="padding:10px;">{{pin.pincode}} - {{pin.cityname}}</div>
                                            </a>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="">Current Age</label>
                                    <input type="text" class="form-control"
                                        placeholder="Enter in years" id="currentAge" [(ngModel)]="currentAge"
                                        name="currentAge" autocomplete="off" (blur)="removeErrorMsg('currentage')"
                                        minlength="2" maxlength="3" (keypress)="numberspincode($event)">
                                    <div class="errormsg" *ngIf="currAgeValidateMessage == 'invalid'">
                                        Current age is not valid
                                    </div>
                                    <div class="errormsg" *ngIf="currAgeValidateMessage == 'required'">
                                        Current age is mandatory
                                    </div>
                                </div>
                                <div class="text-center">
                                    <button type="submit" class="btn btn-primary"
                                        (click)="checkValidationMsg(leadForm)">Download Now!</button>
                                </div>
                            </form>
                        </div>
                        <div class="card-body otp-card" *ngIf="isOtpFormVisible">
                            <div id="main_loader" style="display:none;">
                                <div class="loader-wrapper">
                                    <div class="lds-roller">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                            <h4 class="form-title">Maximize Your Tax Savings Now!</h4>
                            <form #otpForm="ngForm" (ngSubmit)="SubmitOTP(otpForm)">
                                <p><a href="javascript:void(0)" id="btn-back" (click)="changeNumber()"><i
                                            class="fa fa-chevron-left"></i> Change Number</a></p>
                                <div class="alert alert-success">
                                    <i class="fa fa-check"></i>
                                    <span>OTP successfully sent on number {{displayMobile}}</span>
                                </div>
                                <div class="form-group">
                                    <input type="text" autocomplete="off"
                                        (keydown.space)="$event.preventDefault();" (keyup)="removeErrorMsg('otp')"
                                        id="otp" name="otp" [(ngModel)]="userOTP" class="form-control" maxlength="6"
                                        placeholder="Enter OTP" (keypress)="numberspincode($event)">
                                    <div class="errormsg" *ngIf='!otpVerifiedStatus'>
                                        Invalid OTP
                                    </div>
                                    <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
                                        Please enter OTP to continue.
                                    </div>
                                    <div class="errormsg" *ngIf="otpValidateMessage == 'lengthError'">Invalid OTP
                                    </div>
                                </div>
                                <div class="text-center">
                                    <button type="submit" class="btn btn-primary" id="otp_verify_btn"
                                        (click)="otpValidate()">Submit</button>
                                </div>
                                <div class="form-group text-center">
                                    <span *ngIf="isTimer">Didn't recieve OTP? Resend in <strong
                                            style="font-size:17px;">{{timeleft}} </strong>seconds</span>
                                    <a class="resendotp" href="javascript:void(0)" *ngIf="isResend"
                                        (click)="resendOTP()">Resend OTP</a>
                                </div>
                            </form>
                        </div>
                        <div class="card-body success-card" *ngIf="isThanksVisible">
                            <div class="success-tick">
                                <h2>Thank you!</h2>
                            </div>
                            <h6>A member of our care team will get in touch with you shortly.</h6>
                        </div>
                    </div>
                </div>
                <!-- old form end  -->
            </div>
        </div>
    </section>
    <section class="second-section" id="mobilebanner" style="display: none">
        <img src="../../../../assets/images/tax-campaign/Mobile Banner_1383x550 px.webp" alt="mobile banner" width="1383" height="550" loading="eager" rel="preload" as="image">
    </section>
   
    
    <section class="second-section">
        <img src="../../../assets/images/tax-campaign/new2.webp" alt="Tax Campaign New 2" width="5000" height="300" loading="lazy">
    </section>
    <div class="container">
            <img src="../../../assets/images/tax-campaign/3.webp" alt="Duplicate Image Optimized" width="4000" height="300" loading="lazy">
    </div>

    <section class="contact-section">
        <div class="container">
            <div class="row justify-content-center text-center">
                <div class="col-12 col-md-2 mb-3">
                    <img rel="preload" src="../../../assets/images/tax-campaign/4.webp" alt="Image 1" class="img-fluid"  as="image">
                </div>
                <div class="col-12 col-md-2 mb-3">
                    <img src="../../../assets/images/tax-campaign/5.webp" alt="Image 2" class="img-fluid">
                </div>
                <div class="col-12 col-md-2 mb-3">
                    <img src="../../../assets/images/tax-campaign/6.webp" alt="Image 3" class="img-fluid">
                </div>
                <div class="col-12 col-md-2 mb-3">
                    <img src="../../../assets/images/tax-campaign/7.webp" alt="Image 4" class="img-fluid">
                </div>
                <div class="col-12 col-md-2 mb-3">
                    <img src="../../../assets/images/tax-campaign/8.webp" alt="Image 5" class="img-fluid">
                </div>
            </div>
            
        </div>
    </section>

    <div class="container">
        <img src="../../../assets/images/tax-campaign/9.webp" alt="Tax Campaign Image 9" width="2000" height="150" loading="lazy">
    </div>

    <section class="contact-section">
        <div class="container text-center">
            <div class="row">
                <div class="col-md-4">
                        <img src="../../../assets/images/tax-campaign/10.webp" alt="">
                </div>
                <div class="col-md-4 mt-5 mt-md-0">
                        <img src="../../../assets/images/tax-campaign/11.webp" alt="">
                </div>
                <div class="col-md-4 mt-5 mt-md-0">
                        <img src="../../../assets/images/tax-campaign/12.webp" alt="">
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-4">
                        <img src="../../../assets/images/tax-campaign/13.webp" alt="">
                </div>
                <div class="col-md-4 mt-5 mt-md-0">
                        <img src="../../../assets/images/tax-campaign/14.webp" alt="">
                </div>
            </div>
        </div>
    </section>

    <section class="third-section" (click)="download()" style="cursor: pointer;">
        <img src="../../../../assets/images/tax-campaign/new3.webp" alt="Tax Campaign Image" width="5000" height="300" loading="lazy">
    </section>

    <div class="container">
        <p class="col-md-12 mt-3 terms"> <span style="font-weight: bold;">Disclaimer: </span>Bajaj Capital Limited (BCL) (CIN: U67120DL1965PLC004338) is a mutual fund distributor (ARN 0010) registered with AMFI. Registered Office: Mezzanine Floor, Bajaj House 97, Nehru Place, New Delhi-110019. Certain products and services offered by BCL may not be traded on the exchange. All disputes with respect to the distribution activity, would not have access to Exchange Investor Redressal Forum or Arbitration mechanism. In accordance with the applicable laws, BCL is allowed to render incidental advice with respect to mutual fund products only to its mutual fund distribution clients. For every other purpose, including distribution of non-mutual fund products, the circulated material is for informational purposes only. Further, it is not intended as investment advice or an opinion concerning securities or a public offer proving a basis for an investment decision. The views or expressions contained in the circulated material are not necessarily of BCL and BCL neither assumes any responsibility/liability nor does guarantee its accuracy, suitability, completeness and adequacy. The figures and data that may be appearing in the material are taken from various sources and BCL is not responsible for the accuracy of the same. The content of the material including images, charts, graphics and pictures are protected intellectual properties and cannot be amended, copied, reproduced, replicated, republished, uploaded, posted, published, transmitted, displayed or distributed for any non-personal use without obtaining prior written permission, any non-adherence of which may attract appropriate legal action. Mutual Fund investments are subject to market risk, read all scheme-related documents carefully. The past performance of the scheme is not indicative of future performance. Investors are advised to seek appropriate advice from experts before taking any investment decisions. Nothing in the circulated material is intended to construe an advertisement or an investment, financial advice and/or solicitation, advice to buy, sell or deal in any financial product.</p>
    </div>